import { APPLICANT_CREDIT_RATING_REQUESTED_STATUSES } from 'cpool-constants';
import { z } from 'zod';

import { Beschaeftigung } from './Beschaeftigung';
import { PhoneLegitimation } from './Legitimation';
import { Personendaten } from './Personendaten';
import { Wohnsituation } from './Wohnsituation';
import { schemaId } from '../../utils/schema.utils';

export const Applicant = z.object({
    advertisementConsentAgreed: z.boolean().default(false),
    advertisementConsentAgreedAt: z.number().nullable().optional(),
    beschaeftigung: Beschaeftigung,
    creditRatingRequestedStatus: z
        .nativeEnum(APPLICANT_CREDIT_RATING_REQUESTED_STATUSES)
        .default(APPLICANT_CREDIT_RATING_REQUESTED_STATUSES.NOT_REQUESTED),
    dataProtectionAgreed: z.boolean().default(false),
    dataProtectionAgreedAt: z.number().nullable().optional(),
    emailVerified: z.boolean().default(false),
    emailVerifiedAt: z.number().nullable().optional(),
    id: schemaId,
    legitimation: z
        .object({
            telephone: PhoneLegitimation,
        })
        .default({ telephone: [] }),
    personendaten: Personendaten,
    wohnsituation: Wohnsituation,
});

export type Schema_Applicant = z.infer<typeof Applicant>;
